import defaultErrImg from "../assets/img/defaultLogo.png";
function install(Vue) {
  /**
   * 检测图片是否存在
   * @param url
   */
  let imageIsExist = function (url) {
    return new Promise((resolve) => {
      var img = new Image();
      img.onload = function () {
        if (this.complete == true) {
          resolve(true);
          img = null;
        }
      };
      img.onerror = function () {
        resolve(false);
        img = null;
      };
      img.src = url;
    });
  };
  Vue.directive("default-img", async function (el, binding) {
    //指令名称为：v-default-img
    const {src, errImg=defaultErrImg, objectFit="contain"} = binding.value; //获取图片地址
    if (src) {
      const exist = await imageIsExist(src);
      if (exist) {
        el.setAttribute("src", src);
      } else {
        el.style.objectFit = objectFit;
        el.setAttribute("src", errImg);
      }
    } else {
      el.style.objectFit = objectFit;
      el.setAttribute("src", errImg);
    }
  });
}

export default { install };
